/* eslint-disable no-tabs */
<template>
  <div class="container-fluid">
    <TableControls :canSearch="false"/>
    <div class="form-group row">
      <div class="col-md-12">
        <BaseInput
          type="text"
          customClass="form-control-lg w-100"
          placeholder="Offer name"
          v-model="offer.name"
          :error-message="errorMessages['name']"
        />
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="banner text-center">
          <p>
            <input
              class="hidden w-75 mt-3"
              placeholder="Website name"
              v-model="offer.website"
              type="text"
              required
            >
          </p>
          <h1>
            <input
              class="hidden w-75 mt-1 mb-2"
              placeholder="Banner headline"
              v-model="offer.banner"
              type="text"
              required
            >
          </h1>
        </div>
        <OfferStacked
          :offer="offer"
          @handlefile="val => onFileSelected(val)"
          :image="image"
          v-if="offer.layout === 'stacked' && offer.type === 'linkout'"
        />
        <OfferStackedInverse
          :offer="offer"
          @handlefile="val => onFileSelected(val)"
          :image="image"
          v-if="offer.layout === 'stacked-inverse' && offer.type === 'linkout'"
        />
        <OfferWide
          :offer="offer"
          @handlefile="val => onFileSelected(val)"
          :image="image"
          v-else-if="offer.layout === 'wide' && offer.type === 'linkout'"
        />
        <CustomOfferByCategory
          :offer="offer"
          v-else-if="offer.type === 'custom' && offer.customType === 'category'"
        />
        <CustomOfferCreditCheck
          :offer="offer"
          v-else-if="offer.type === 'custom' && offer.customType === 'check'"
        />
        <CustomOfferGlobal
          :offer="offer"
          v-else-if="offer.type === 'custom' && offer.customType === 'global'"
        />
      </div>
    </div>
    <div v-if="showAdvanced" class="d-flex justify-content-center pointer mt-2">
      <button class="hidden-button" @click="showAdvanced = !showAdvanced">Hide advanced</button>
    </div>
    <div v-else class="d-flex justify-content-center pointer mt-2">
      <button class="hidden-button" @click="showAdvanced = !showAdvanced">Show advanced</button>
    </div>
    <transition name="slide-fade" v-if="showAdvanced">
      <div class="advanced-options">
        <div class="form-row mb-3 mt-3">
          <div :class="['input-group',  offer.type === 'custom' ? 'col-md-3' : 'col-md-4']">
            <div class="input-group-prepend">
              <label class="input-group-text" for="type">
                <i class="fa fa-play-circle mr-1"></i>
              </label>
            </div>
            <select class="custom-select" id="linkout" v-model="offer.type">
              <option value="linkout" selected>Linkout</option>
              <option value="custom">Custom</option>
            </select>
          </div>
          <div
            :class="['input-group',  offer.type === 'custom' ? 'col-md-3' : 'col-md-4']"
            v-if="offer.type === 'custom'"
          >
            <div class="input-group-prepend">
              <label class="input-group-text" for="type">
                <i class="far fa-clone mr-1"></i>
              </label>
            </div>
            <select class="custom-select" id="linkout" v-model="offer.customType">
              <option value disabled selected>Select Type</option>
              <option value="category">Lead5 Job Category</option>
              <option value="global">Lead5 Global</option>
              <option value="check">Credit Check</option>
            </select>
          </div>
          <div class="input-group col-md-4" v-if="offer.type !== 'custom'">
            <div class="input-group-prepend">
              <label class="input-group-text" for="layout">
                <i class="fa fa-eye mr-1"></i>
              </label>
            </div>
            <select class="custom-select" id="layout" v-model="offer.layout">
              <option value="stacked" selected>Stacked</option>
              <option value="stacked-inverse">Stacked Inverse</option>
              <option value="wide">Wide</option>
            </select>
          </div>

          <div :class="['input-group',  offer.type === 'custom' ? 'col-md-3' : 'col-md-4']">
            <div class="input-group-prepend">
              <span class="input-group-text">CPC $</span>
            </div>
            <input
              type="text"
              class="form-control"
              v-model="offer.cpc"
              placeholder="Example: $3.00"
            >
          </div>

          <div class="input-group col-md-3" v-if="offer.type === 'custom'">
            <div class="input-group-prepend">
              <label class="input-group-text" for="cid">CID</label>
            </div>
            <BaseInput
              class="form-control"
              type="text"
              v-model="offer.cid"
              :error-message="errorMessages['CID']"
              placeholder="CID"
            />
          </div>
        </div>
        <div class="form-row" v-if="offer.type !== 'custom'">
          <div class="form-group col-md-8">
            <div class="input-group">
              <div class="input-group-prepend">
                <span class="input-group-text" id="basic-addon1">
                  <i class="fa fa-link"></i>
                </span>
              </div>
              <input
                v-if="!offer.linkOutButtonLinkParamsComplete"
                type="text"
                class="form-control"
                placeholder=" Example: https://affiliatetracker.com?lead_id="
                v-model="offer.linkOutButtonLink"
              >
              <input
                v-else
                type="text"
                class="form-control"
                placeholder="https://affiliatetracker.com?params"
                v-model="offer.linkOutButtonLinkParamsComplete"
              >
            </div>
          </div>
          <div class="form-group col-md-2">
            <div class="input-group form-group">
              <button
                class="hidden-button tokenBtn pointer"
                @click="paramModal = !paramModal"
              >Tokens</button>
            </div>
          </div>
          <div class="form-group col-md-2">
            <div class="input-group">
              <input
                type="checkbox"
                class="form-check-input align-middle"
                id="newWindow"
                v-model="offer.newWindow"
              >
              <label class="form-check-label align-middle" for="newWindow">New Window?</label>
            </div>
          </div>
        </div>
        <div class="form-row">
          <div class="form-group ml-4">
            <div class="input-group">
              <input
                type="checkbox"
                class="form-check-input"
                id="disclaimerLink"
                v-model="offer.disclaimerLink"
              >
              <label class="form-check-label" for="disclaimerLink">Turn Disclaimer into Link?</label>
            </div>
          </div>
        </div>
      </div>
    </transition>
    <hr>
    <div class="d-flex flex-row justify-content-end">
      <BaseButton v-if="!edit" style-type="action" @click.native="createOffer()">Create</BaseButton>
      <BaseButton v-else style-type="action" @click.native="editOffer()">Save</BaseButton>
      <router-link to="/offers" class="greyBtn">Cancel</router-link>
    </div>
    <Modal v-if="paramModal" @close="paramModal = false" width="medium">
      <h3 slot="header">URL Tokens</h3>
      <div slot="body">
        <div class="form-row p-1" v-for="(param, index) in paramsArray" :key="param.id">
          <input class="form-control col-md-6" type="text" v-model="param.key ">
          <div class="input-group col-md-6">
            <select class="form-control" type="text" v-model="param.value">
              <option selected>Select a token</option>
              <option>utm_source</option>
              <option>lead_id</option>
              <option>first_name</option>
              <option>last_name</option>
              <option>email</option>
              <option>phone-cell</option>
              <option>address1</option>
              <option>city</option>
              <option>state</option>
              <option>zip_code</option>
              <option>job</option>
              <option>job_category</option>
              <option>search_text</option>
              <option>clickid</option>
            </select>
            <div class="input-group-append">
              <button class="deleteParam" @click="deleteParam(index)">
                <i class="fas fa-trash-alt"></i>
              </button>
            </div>
          </div>
        </div>
        <div class="d-flex justify-content-center mt-3">
          <button
            class="hidden-button addParam"
            style="background-color:white;"
            @click="addtoken()"
          >Add Token</button>
        </div>
      </div>
      <div slot="footer">
        <button class="greyBtn smBtn mr-1" @click="paramModal = false">Cancel</button>
        <button class="blueBtn smBtn ml-1" @click="paramModal = false, formatParams()">Update</button>
      </div>
    </Modal>
  </div>
</template>
<script>
import Offers from '@/resources/Offers.js'
import Images from '@/resources/Images.js'
import DAISY_ENV from '@/resources/env.js'

export default {
  data () {
    return {
      edit: false,
      showAdvanced: true,
      paramModal: false,
      errorMessages: {},
      paramsArray: [],
      customOffer: 'customOne',
      offer: {
        name: '',
        banner: 'We found a job near you.',
        headline: '',
        tagline: '',
        imageUrl: '',
        disclaimer: '',
        website: '',
        linkOutButtonText: 'Apply now',
        nextButtonText: 'Next',
        linkOutButtonLink: null,
        newWindow: true,
        disclaimerLink: false,
        cpc: '',
        cid: '3574',
        layout: 'stacked',
        type: 'linkout',
        customType: '',
        linkOutButtonLinkParams: {},
        linkOutButtonLinkParamsComplete: null
      },
      selectedFile: null,
      selectedFileSize: null,
      image: '',
      itemsToDelete: [
        'created_at',
        'deleted_at',
        'uuid',
        'updated_at',
        'edited_by'
      ]
    }
  },
  mounted () {
    if (this.$route.params.id) {
      this.edit = true
      this.getSingleOffer()
    }
  },
  methods: {
    addToPreview (linkparams) {
      var queryStrings = '?'
      if (!linkparams || Object.keys(linkparams).length < 1) {
        delete this.offer.linkOutButtonLinkParamsComplete
        return this.offer.linkOutButtonLink
      }
      if (this.offer.linkOutButtonLink.includes('?')) {
        queryStrings = '&'
      }
      for (var param in linkparams) {
        queryStrings += param + '=' + '{{' + linkparams[param] + '}}' + '&'
      }
      this.offer.linkOutButtonLinkParamsComplete =
        this.offer.linkOutButtonLink + queryStrings
    },
    addtoken () {
      this.paramsArray.push({ key: '', value: '' })
    },
    prepareOffer (offer) {
      let newOffer = { name: offer.name, attributes: [] }
      offer = JSON.parse(JSON.stringify(offer))
      delete offer.name
      for (var item in offer) {
        newOffer.attributes.push({ attribute: item, value: offer[item] })
      }
      return newOffer
    },
    onFileSelected (event) {
      this.selectedFile = event.target.files[0]
      this.selectedFileSize = this.selectedFile.size
      if (this.selectedFileSize > 102400) {
        delete this.selectedFile
        // TODO: add styling to toast notification and configuration
        return this.$toast('File is to large, only files of 10kb are allowed', {
          error: true
        })
      } else if (this.selectedFile) {
        const reader = new FileReader()
        reader.onload = e => {
          this.image = e.target.result
          // upload image here
          let formData = new FormData()
          formData.append('image', event.target.files[0])
          formData.append('name', 'file001')
          Images.upload(formData).then(response => {
            this.offer.imageUrl = DAISY_ENV.DAISY_IMAGES_URL() + response.url
          })
        }
        reader.readAsDataURL(this.selectedFile)
      }
    },
    getSingleOffer () {
      const id = this.$route.params.id
      Offers.show(id).then(res => {
        this.itemsToDelete.forEach(e => delete res[e])
        if (!res.cid || res.cid === '') res.cid = '3574'
        this.offer = res
        this.prepareTokensToEdit(
          JSON.parse(this.offer.linkOutButtonLinkParams)
        )
      })
    },
    prepareTokensToEdit (parsedTokens) {
      for (const key in parsedTokens) {
        this.paramsArray.push({ key: key, value: parsedTokens[key] })
      }
    },
    createOffer () {
      this.formatParams()
      Offers.create(this.prepareOffer(this.offer)).then(res => {
        if (res.error && res.status === 422) {
          this.errorMessages = res.body
        } else {
          this.$toast(`${res.name} sucessfuly created.`)
          this.showAdvanced = false
        }
      })
    },
    editOffer () {
      const id = this.$route.params.id
      Offers.patch(id, this.prepareOffer(this.offer)).then(res => {
        if (res.error && res.status === 422) {
          this.errorMessages = res.body
        } else {
          this.$toast(res.message)
          this.showAdvanced = false
        }
      })
    },
    formatParams () {
      let linkparams = {}
      for (var i = 0; i < this.paramsArray.length; i++) {
        linkparams[this.paramsArray[i].key] = this.paramsArray[i].value
      }
      this.offer.linkOutButtonLinkParams = JSON.stringify(linkparams)
      this.addToPreview(linkparams)
    },
    deleteParam (index) {
      this.paramsArray.splice(index, 1)
    }
  },
  computed: {},
  components: {}
}
</script>
<style lang="scss">
.addParam {
  align-self: center;
  border: 1px solid $mainColor;
  height: 30px;
  border-radius: 50%;
  -moz-border-radius: 50%;
  -webkit-border-radius: 50%;
}
.deleteParam {
  outline: none;
  border: none;
}
input[type="checkbox"] {
  background-color: $mainColor;
}
.advanced-options .input-group {
  flex-wrap: nowrap;
  input,
  span,
  select,
  .input-group-prepend,
  .input-group-text {
    border: none;
  }
  .input-group-prepend,
  .input-group-text {
    min-width: 50px;
    background-color: $container-bg;
    i:before {
      margin: 0px;
    }
  }
}
.tokenBtn {
  padding: 8px 16px;
  line-height: 18px;
  font-size: 16px;
}
.hidden-button {
  background-color: $container-bg;
  color: $mainColor;
  &:hover {
    background-color: $container-bg;
  }
}
.fa-link:before {
  margin: 10px;
}
.image-upload,
.placeholder {
  input {
    display: none;
  }
}
.hidden {
  text-align: center;
  border: none;
  outline: none;
  h2 {
    font-size: 26px;
    font-weight: 200;
  }
}
.blend {
  background-color: #f2f2f2;
}
.banner {
  font-size: 18px;
  background-color: #2eaadf;
  min-height: 65px;
  width: 100%;
  border-radius: 6px;
  input {
    background-color: transparent;
    color: white;
  }
  ::placeholder {
    color: white;
  }
  p {
    margin: 0px;
    padding: 0px;
  }
}
</style>
